/**
 * Video Player.
 * (Used in PDPs)
 */

/**
 * Mobile: Video plays in fullscreen on tap.
 * Desktop: Video autoplays. Pause/play button appears on hover.
 */

let 
	$window = $(window),
	breakpoint = 1024,
	prevWindowW = $window.width(),
	currWindowW = prevWindowW,
	$myPlayer = $('.video-player'),
	$myVideoDe = $('.video.desktop'),
	my_video_de = $myVideoDe[0],
	$myVideoMo = $('.video.mobile'),
	my_video_mo = $myVideoMo[0],
	$myBtns = $('.video-blade__btns'),
	$myPauseBtn = $('.pause'),
	$myPlayBtn = $('.play');

 function initVideoPlayerDesktop() {
	// console.log('VIDEO PLAYER: initVideoPlayerDesktop()');

	$myBtns.hide();

	// PAUSE.
	$myPauseBtn.on('click', function() {
		my_video_de.pause();	// Pause video.
		$myPauseBtn.hide();		// Show PLAY btn.
		$myPlayBtn.show();
		$myPlayer.off();		// Button always visible.
	});

	// PLAY.
	$myPlayBtn.off();
	$myPlayBtn.on('click', function() {
		my_video_de.play();		// Play video.
		$myPauseBtn.show();		// Show PAUSE btn.
		$myPlayBtn.hide();
		initShowBtnsOnHover();	// Show button on hover.
	});

	// Desktop. Show buttons on hover.
	function initShowBtnsOnHover() {
		$myPlayer.on('mouseenter', function() {
			if ((my_video_de.paused) | (my_video_de.ended)) {
				$myPauseBtn.hide();
				$myPlayBtn.show();
			} else {
				$myPauseBtn.show();
				$myPlayBtn.hide();
			}
			$myBtns.fadeIn(200);
		});
		$myPlayer.on('mouseleave', function() {
			$myBtns.fadeOut(200);
		});
	}

	initShowBtnsOnHover();

	// Desktop. Show PLAY button on video end.
	function videoEnded() {
		// console.log('VIDEO PLAYER: videoEnded()');
		$myPauseBtn.hide();
		$myPlayBtn.show();
		$myBtns.fadeIn(200);
		$myPlayer.off();
	}

	// If video paused on init, show (PLAY) button.
	// if (my_video_de.duration != 'NaN') {
	// console.log('VIDEO PLAYER: initVideoPlayerDesktop(): paused: '+my_video_de.paused);
	if (my_video_de.paused && (my_video_de.currentTime > 0)) {
		videoEnded();
	}
	// }
	// my_video_de.onloadedmetadata = function() {
	// 	if ((my_video_de.currentTime == my_video_de.duration) || (my_video_de.paused)) {
	// 		console.log('VIDEO PLAYER: my_video_de.currentTime: '+my_video_de.currentTime);
	// 		console.log('VIDEO PLAYER: my_video_de.duration: '+my_video_de.duration);
	// 		console.log('VIDEO PLAYER: my_video_de.paused: '+my_video_de.paused);
	// 		videoEnded();
	// 	}
	// };

	// On video end, show (PLAY) button.
	my_video_de.onended = function() {
		videoEnded();
	};
 }

 function initVideoPlayerMobile() {
	$myVideoMo.hide();		// Hide inline video (only show in fullscreen).
	$myPauseBtn.hide();		// Show PLAY btn.
	$myPlayBtn.show();
	$myBtns.show();

	// PLAY.
	$myPlayBtn.off();
	$myPlayBtn.on('click', function() {
		$myVideoMo.show();
		doFullscreen(my_video_mo);
		my_video_mo.play();
	});
 }

 function doFullscreen(video) {
	if (video.requestFullscreen) { 
		// for most browsers
		video.requestFullscreen(); 
	} else if (video.webkitRequestFullscreen) { 
		// for Safari (older versions)
		video.webkitRequestFullscreen(); 
	} else if (video.webkitEnterFullscreen) { 
		// for Safari (newer versions)
		video.webkitEnterFullscreen(); 
	} else if (video.children[0].webkitEnterFullscreen) {
		// for Safari iPhone (where only the Video tag itself can be fullscreen)
		video.children[0].webkitEnterFullscreen();
	}
	// When user exits full screen, hide video in page.
	document.addEventListener("fullscreenchange", function() {
		if (document.fullscreenElement) {
		
		} else {
			$myVideoMo.hide();
		}
	});
}

function initVideoPlayer() {
	currWindowW = $window.width();

	// Viewport is desktop.
	if ((currWindowW >= breakpoint)) {
		// On first load in desktop, play video.
		// Video is set to autoplay in HTML, but need to force video's paused to false, which autoplay fails to do.
		// my_video_de.play(); TURNS OUT THIS IS NOT ALLOWED. Video can only play on user request.
		initVideoPlayerDesktop();
	}
	// Viewport is mobile.
	if ((currWindowW < breakpoint)) {
		initVideoPlayerMobile();
	}
	prevWindowW = $window.width();	
}

function initResizeWatcher() {
	// console.log('VIDEO PLAYER: initResizeWatcher()');

	// Viewport is currently in mobile (on page load).
	if ((currWindowW < breakpoint) ) {

	}

	// Viewport is currently in desktop (on page load).
	if ((currWindowW >= breakpoint) ) {

	}
	
	$window.on('resize', function() {
		currWindowW = $window.width();

		// Viewport width crosses from mobile to desktop.
		if ((currWindowW >= breakpoint) && (prevWindowW < breakpoint)) {
			initVideoPlayerDesktop();
		}
		// Viewport width crosses from desktop to mobile.
		if ((currWindowW < breakpoint) && (prevWindowW >= breakpoint)) {
			initVideoPlayerMobile();
		}
		prevWindowW = $window.width();
	});
}


 exports.init = function () {
	// console.log('VIDEO PLAYER: exports.init');
    // Run init methods...

	initVideoPlayer();
	initResizeWatcher();
};